import React from 'react';
import '../../App.css';
import ConsigneeStationMasterForm from '../ConsigneeStationMaster';
import AccessDenied from '../AccessDenied';

function ConsigneeStationMaster({ sessionObject }) {
  // const hasAccess = sessionObject.sessionVariables["modules"]?.includes(
  //   "consignee_station_master"
  // );

  // if (!hasAccess) {
  //   return (
  //     <div className="page-mr">
  //       <AccessDenied moduleName="Consignee Station Master" />
  //     </div>
  //   );
  // }

  return (
    <div className="page-mr">
      <ConsigneeStationMasterForm sessionObject={sessionObject} />
    </div>
  );
}

export default ConsigneeStationMaster;
